import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-screen",
  "use": "icon-screen-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-screen\"><path d=\"M817.152 244.352H235.648c-35.328 0-64 28.672-64 64v328.96c0 35.328 28.672 64 64 64h581.376c35.328 0 64-28.672 64-64v-328.96c0.128-35.328-28.672-64-63.872-64z m12.8 392.96c0 7.04-5.76 12.8-12.8 12.8H235.648c-7.04 0-12.8-5.76-12.8-12.8v-328.96c0-7.04 5.76-12.8 12.8-12.8h581.376c7.04 0 12.8 5.76 12.8 12.8v328.96zM325.888 791.808H727.04v51.2H325.888z\" fill=\"#2681ff\" p-id=\"2578\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol